<template>
  <v-container class="p-3 mt-3">
    <loading-flux :value="loading"></loading-flux>
    <header
      class="d-flex flex-column flex-sm-row justify-content-between"
      v-if="showHeader"
    >
      <h2 class="ml-1 my-2">
        {{ title }}
      </h2>
      <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
    </header>
    <v-row align-content="start" align-md="start" class="mt-1">
      <slot name="actions"></slot>
      <v-col cols="12" md="3" sm="12" class="py-0">
        <v-text-field
          v-model="filters.filter"
          @input="getRequestServicesQuotesData(1)"
          class="mt-5"
          clearable
          placeholder="Buscar:"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" sm="12" class="pb-0">
        <v-autocomplete
          v-model="filters.status_filter"
          clearable
          :items="statusFilterOptions"
          item-text="name"
          item-value="value"
          @input="getRequestServicesQuotesData(1)"
          label="Filtrar por Estatus"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3" sm="12" class="pb-0">
        <v-autocomplete
          v-model="filters.business_unit"
          clearable
          :items="businessUnits"
          @input="getRequestServicesQuotesData(1)"
          class=""
          item-text="name"
          item-value="name"
          no-data-text="Sin Unidades de Negocio"
          label="Filtrar por Unidad de Negocio"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3" sm="12" class="pb-0">
        <v-autocomplete
          v-model="filters.assigned_filter"
          clearable
          :items="[
            {
              email: REQUEST_SERVICE_CONSTANTS.unassigned_purchase_user,
              label: 'Sin Comprador Asignado',
            },
            ...wrappedListEmployeesToAssignRequestOc,
          ]"
          @input="getRequestServicesQuotesData(1)"
          @update:search-input="getListEmployeesToAssignRequestOcData"
          class=""
          item-text="label"
          item-value="email"
          no-data-text="Sin Usuarios Compradores"
          label="Filtrar por Comprador Asignado"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3" sm="12" class="pb-0" v-if="requestPurchaseOrder">
        <filter-project
          ref="filterProject"
          :projects="
            projects.items
              ? projects.items.filter((item) => item.warehouse)
              : []
          "
          :getProjectsFunction="getProjects"
          @cleanProject="cleanCurrentProject"
          @inputProject="
            changeProjectFilter();
            updateCurrentProject($event);
          "
        ></filter-project>
      </v-col>
      <v-col cols="12" md="3" sm="12" class="" v-if="requestPurchaseOrder">
        <filter-ceco
          :cecos="cecos.items ? cecos.items : []"
          :getCecosFunction="getCecos"
          @cleanCeco="cleanCurrentCeco"
          @inputCeco="
            updateCurrentCeco($event);
            getRequestServicesQuotesData(1);
          "
        ></filter-ceco>
      </v-col>
      <v-col cols="12" md="3" sm="12" class="pb-0">
        <v-menu
          ref="menu"
          v-model="datepicker_menu_start"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date_start_formatted"
              prepend-icon="mdi-calendar"
              readonly
              label="Filtrar por Fecha (Desde)"
              v-bind="attrs"
              v-on="on"
              clearable
              @click:clear="clearDateFilters"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.date_start"
            scrollable
            locale="es"
            :max="maxDateStart"
            @input="
              datepicker_menu_start = false;
              getRequestServicesQuotesData(1);
            "
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="3" sm="12" class="pb-0">
        <v-menu
          ref="menu"
          v-model="datepicker_menu_end"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date_end_formatted"
              prepend-icon="mdi-calendar"
              readonly
              label="Filtrar por Fecha (Hasta)"
              v-bind="attrs"
              v-on="on"
              clearable
              @click:clear="clearDateFilters"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="filters.date_end"
            scrollable
            locale="es"
            clearable
            :min="minDateEnd"
            @input="
              datepicker_menu_end = false;
              getRequestServicesQuotesData(1);
            "
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-data-table
      :key="keyTableRequests"
      class="px-1 elevation-3 mt-3"
      :headers="wrappedHeaders"
      :items="filteredRequestServicesQuotesItems"
      :items-per-page="-1"
      hide-default-footer
      :loading="loadingQuotes"
      loading-text="Cargando Cotizaciones"
      item-key="id"
      show-expand
      :expanded.sync="expanded"
      no-data-text="Sin Cotizaciones"
      @update:sort-by="updateSortBy"
      @update:sort-desc="updateSortDesc"
      :custom-sort="customSort"
    >
      <template v-slot:item="{ item, isExpanded }">
        <tr
          :class="rowColor(item)"
          @click="
            clickedRow(item);
            updateStatusInReviewRequest(item);
          "
        >
          <td>
            <v-menu :close-on-content-click="true">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  class="blue darken-3"
                  fab
                  x-small
                  outlined
                >
                  <v-icon color="white"> mdi-dots-vertical </v-icon>
                </v-btn>
              </template>
              <v-list rounded>
                <v-list-item
                  class="mb-0 pl-1"
                  v-show="
                    (requestIsStatusInPurchaseValidation(item) &&
                      !requestingUserModule &&
                      item.is_maverick) ||
                      (requestIsStatusInPurchaseValidationVariant(item) &&
                        !requestingUserModule &&
                        !item.is_maverick &&
                        !REQUEST_SERVICE_CONSTANTS.ifRequestHasQuotesUploadedByUserWithInvalidSupplier(
                          item,
                        ))
                  "
                >
                  <v-list-item-title
                    @click="updateStatusRequest(item)"
                    x-small
                    class="pointer"
                  >
                    <span class="mr-2" style="font-size: 1.1rem"> 👌 </span>
                    Enviar Solicitud a Matriz de Aprobación
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="mb-0 pl-1"
                  v-if="
                    (requestIsStatusInPurchaseValidation(item) &&
                      !requestingUserModule &&
                      item.is_maverick) ||
                      (requestIsStatusInPurchaseValidationVariant(item) &&
                        !requestingUserModule &&
                        !item.is_maverick)
                  "
                >
                  <v-list-item-title
                    @click="updateStatusRequestToReviewUser(item)"
                    x-small
                    class="pointer"
                  >
                    <span class="mr-2" style="font-size: 1.1rem"> ⚠️ </span>
                    Enviar Solicitud a Revisión por el Usuario
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="mb-0 pl-1"
                  v-if="
                    (requestIsStatusInUserValidation(item) &&
                      requestingUserModule &&
                      item.is_maverick) ||
                      (!item.is_maverick &&
                        requestingUserModule &&
                        requestIsStatusUserValidationVariant(item))
                  "
                >
                  <v-list-item-title
                    @click="updateStatusRequestToReviewPurchase(item)"
                    x-small
                    class="pointer"
                  >
                    <span class="mr-2" style="font-size: 1.1rem"> 👌 </span>
                    <span> Enviar Solicitud a Revisión por Compras </span>
                  </v-list-item-title>
                </v-list-item>

                <v-list-item
                  class="mb-0 pl-0"
                  v-if="
                    (item.is_maverick &&
                      !requestingUserModule &&
                      requestIsStatusInPurchaseValidation(item)) ||
                      (requestIsStatusInUserValidation(item) &&
                        item.is_maverick &&
                        (requestingUserModule ||
                          REQUEST_SERVICE_CONSTANTS.isRequestCancelationHas14DaysDiffFromToday(
                            item,
                          ))) ||
                      (!item.is_maverick &&
                        requestingUserModule &&
                        requestIsStatusUserValidationVariant(item)) ||
                      (!item.is_maverick &&
                        !requestingUserModule &&
                        requestIsStatusInPurchaseValidationVariant(item))
                  "
                >
                  <v-list-item-title
                    @click="updateStatusRequestToRejection(item)"
                    x-small
                    class="pointer"
                  >
                    <v-icon class="text-danger mx-1">
                      mdi-close-circle-outline
                    </v-icon>
                    <span> Rechazar Solicitud</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="mb-0 mt-0 pl-1">
                  <v-list-item-title
                    @click="openModalCommentsRequest(item)"
                    x-small
                    style="margin-top: -1rem"
                    class="pointer"
                  >
                    <v-badge
                      :content="
                        item.comments && item.comments.length
                          ? item.comments.length
                          : '0'
                      "
                      :color="
                        item.comments && item.comments.length
                          ? 'success'
                          : 'red'
                      "
                      overlap
                    >
                      <v-icon
                        class="mr-2"
                        color="primary"
                        style="font-size: 1.1rem; margin-top: -2px"
                      >
                        mdi-comment-outline
                      </v-icon>
                    </v-badge>
                    <span class="mx-2"> Comentarios </span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="mb-0 pl-1"
                  @click.stop="handleAnularSOC(item)"
                >
                  <v-list-item-title
                    x-small
                    :class="{
                      pointer: canCancelPurchaseOrderRequest(item),
                      'text--disabled': !canCancelPurchaseOrderRequest(item),
                    }"
                  >
                    <v-icon class="mr-2" color="red darken-2">
                      mdi-cancel
                    </v-icon>
                    Anular / Cancelar SOC
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="mb-0 pl-1" v-if="!item.is_maverick">
                  <v-list-item-title
                    @click="openModalServicesDeleted(item)"
                    x-small
                    class="pointer"
                  >
                    <v-icon class="mr-2" color="red">
                      mdi-delete-outline
                    </v-icon>
                    Ver Servicios Eliminados
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </td>
          <td>
            <span class="mt-2" style="font-size: 10.5px">
              {{ item.sale_order }}
            </span>
          </td>
          <td v-if="requestPurchaseOrder">
            <span class="mt-2" style="font-size: 10.5px;">
              {{ item.project ? getCustomProjectCodeIfIsOv(item.project) : item.cost_center.name }}
            </span>
          </td>
          <td v-if="requestPurchaseOrder">
            <span
              :class="{
                'text-primary font-weight-bold':
                  item.is_maverick && !item.is_unique_supplier,
                'text-unique-supplier font-weight-bold':
                  item.is_unique_supplier,
              }"
              class="mt-2"
              style="font-size: 10.5px"
            >
              {{
                !item.request_type
                  ? "-"
                  : item.request_type == REQUEST_MATERIAL
                  ? "SOC"

                  : item.request_type === REQUEST_SERVICE_MAVERICK
                  ? "MAVERICK"

                  : item.is_unique_supplier
                  ? "PROVEEDOR UNICO"
                  : item.is_maverick
                  ? "MAVERICK"
                  : "SSU"
              }}
            </span>
          </td>
          <td>
            <span class="mt-2" style="font-size: 10.5px">
              {{ item.created_by }}
            </span>
          </td>
          <td>
            <span
              class="mt-2"
              style="font-size: 10.5px"
              v-if="
                requestingUserModule ||
                  (item.approval_request &&
                    (item.approval_request.cancelled ||
                      item.approval_request.rejected ||
                      item.approval_request.sent_to_erp)) ||
                  item.cancelled ||
                  item.rejected
              "
            >
              {{
                item.assigned_users && item.assigned_users.length
                  ? item.assigned_users[0].user.email
                  : "Sin Asignar"
              }}
            </span>
            <v-autocomplete
              v-else
              class="py-1 custom-font"
              :items="wrappedListEmployeesToAssignRequestOc"
              v-model="item.assigned_user"
              item-text="label"
              item-value="id"
              searchable
              placeholder="Selecciona un usuario"
              @change="assignUserToRequest($event, item)"
              hide-details
            ></v-autocomplete>
          </td>
          <td>
            <span class="mt-2" style="font-size: 10.5px">
              {{ formatDateToFormatCommon(new Date(item.created_at)) }}
            </span>
          </td>
          <td>
            <span class="mt-2" style="font-size: 10.5px">
              {{ formatDateToFormatCommon(new Date(item.updated_at)) }}
            </span>
          </td>
          <td>
            <div class="d-flex align-items-center justify-content-between">
              <span class="mt-2" style="font-size: 10.5px">
                {{ showCurrentApprover(item) }}
              </span>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    style="width: 26px; height: 26px;"
                    @click.stop="openModalShowApprovers(item)"
                    elevation="0"
                    v-on="on"
                    v-bind="attrs"
                    color="blue darken-3"
                    class="text-white ml-2"
                    :disabled="!item.approval_request"
                    fab
                  >
                    <v-icon x-small color="white"> mdi-eye </v-icon>
                  </v-btn>
                </template>
                <span>Ver Aprobadores</span>
              </v-tooltip>
            </div>
          </td>
          <td >
            <v-chip
              v-if="
                item.approval_request &&
                  (item.approval_request.cancelled ||
                    item.approval_request.rejected ||
                    item.approval_request.sent_to_erp)
              "
              label
              small
              :color="getStatusColorApprovalRequest(item)"
              class="mt-2 text-white"
            >
              <span style="font-size: 10.5px">
                {{
                  item.approval_request.cancelled
                    ? "Anulada"
                    : item.approval_request.rejected
                    ? "Rechazada"
                    : item.approval_request.sent_to_erp &&
                      item.approval_request.sale_approvers.length &&
                      !item.approval_request.sale_order_created
                    ? "Pendiente de Aprobación"
                    : item.approval_request.sent_to_erp &&
                      !item.approval_request.sale_approvers.length
                    ? "Aprobada"
                    : item.approval_request.sent_to_erp &&
                      item.approval_request.sale_order_created
                    ? "OC Aprobada"
                    : REQUEST_SERVICE_CONSTANTS.ifAllServicesHaveOC(item)
                    ? "OC Disponible"
                    : "Pendiente de Aprobación"
                }}
              </span>
            </v-chip>
            <template v-else>
              <v-menu
                v-if="canOpenQuickStatusActionsFromBadge(item)"
                offset-y
                :close-on-content-click="true"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    label
                    small
                    :color="getStatusColorDisplay(item.status)"
                    class="mt-2 text-white pointer"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop
                  >
                    <span style="font-size: 10.5px">
                      {{ getStatusCorrectionDisplay(item.status) }}
                    </span>
                  </v-chip>
                </template>
                <v-list dense class="soc-status-action-list">
                  <v-list-item
                    class="soc-status-action-item"
                    @click.stop="openSocStatusDecisionModal(item, 'rejected')"
                  >
                    <v-list-item-title class="pointer soc-status-action-title">
                      <v-icon class="text-danger soc-status-action-icon">
                        mdi-close-circle-outline
                      </v-icon>
                      Rechazado
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    class="soc-status-action-item"
                    @click.stop="openSocStatusDecisionModal(item, 'cancelled')"
                  >
                    <v-list-item-title class="pointer soc-status-action-title">
                      <v-icon class="soc-status-action-icon" color="red darken-2">
                        mdi-cancel
                      </v-icon>
                      Anulado
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-chip
                v-else
                label
                small
                :color="getStatusColorDisplay(item.status)"
                class="mt-2 text-white"
              >
                <span style="font-size: 10.5px">
                  {{ getStatusCorrectionDisplay(item.status) }}
                </span>
              </v-chip>
            </template>
          </td>
          <td>
            <v-icon>
              {{ isExpanded ? "mdi-chevron-up" : "mdi-chevron-down" }}
            </v-icon>
          </td>
        </tr>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="bg-gray">
          <section class="my-5 px-3">
            <table-services-detail
              ref="tableServicesDetail"
              :requestingUserModule="requestingUserModule"
              :request-service="item"
              @getRequestServicesAndUpdateTable="
                getRequestServicesQuotesData(filters.page, false, true)
              "
              @getRequestsService="getRequestServicesQuotesData(filters.page)"
              @getRequestsServiceAndUpdateCurrentService="
                getRequestServicesQuotesData(filters.page, true, false)
              "
              class="mt-5"
              :requestQuote="requestQuote"
              :requestPurchaseOrder="requestPurchaseOrder"
            ></table-services-detail>
          </section>
        </td>
      </template>
    </v-data-table>
    <div class="my-3 d-flex justify-content-end">
      <v-pagination
        color="blue darken-3"
        total-visible="8"
        :value="filters.page"
        :disabled="loadingQuotes"
        @input="changeQuotesPage"
        :length="
          requestServicesQuotes.total_pages
            ? requestServicesQuotes.total_pages
            : 1
        "
      ></v-pagination>
    </div>
    <modal-comments-service
      :modalAction="dialogCommmentsRequest"
      :closeModalComments="closeModalCommentsRequest"
      :currentRequest="currentRequest"
      @commentAdded="getRequestServicesQuotesData(filters.page)"
    >
    </modal-comments-service>
    <modal-services-deleted
      :modalAction="dialogServicesDeleted"
      :closeModalServicesDeleted="closeModalServicesDeleted"
      :currentRequest="currentRequest"
    >
    </modal-services-deleted>
    <modal-show-approvers
      :modalAction="dialogShowApprovers"
      :closeModalShowApprovers="closeModalShowApprovers"
      :currentRequest="currentRequest"
    ></modal-show-approvers>
    <v-dialog v-model="dialogCancelSoc" max-width="650" persistent>
      <v-card>
        <v-card-title class="text-h6">
          Anular / Cancelar SOC
        </v-card-title>
        <v-card-text>
          <p class="mb-4">
            ¿Estás seguro de que deseas anular esta Solicitud de Orden de Compra?
          </p>
          <p v-if="currentSocToCancel" class="mb-4">
            Cesta de Compra:
            <strong>{{ currentSocToCancel.sale_order }}</strong>
          </p>
          <v-textarea
            v-model="cancelSocReason"
            outlined
            rows="3"
            no-resize
            label="Motivo de anulación"
            placeholder="Ingresa un motivo opcional"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="grey darken-1"
            :disabled="cancelSocLoading"
            @click="closeCancelSocDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="red darken-2"
            class="text-white"
            :loading="cancelSocLoading"
            :disabled="cancelSocLoading || !currentSocToCancel"
            @click.stop="handleConfirmAnulacion"
          >
            Confirmar Anulación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { authUsuarioComputed } from "@/state/helpers";
import FilterProject from "@/components/commons/projects/FilterProject.vue";
import FilterCeco from "@/components/commons/cecos/FilterCeco.vue";
import TableServicesDetail from "../components/TableServicesDetail.vue";
import {
  REQUEST_MATERIAL,
  
  REQUEST_SERVICE,
  REQUEST_SERVICE_MAVERICK,
  TYPE_REQUESTS_SERVICE,
  STATUS_REQUESTS_MATERIALS,
} from "@/constants/requestMaterial";
import REQUEST_SERVICE_CONSTANTS from "@/constants/requestService";
import ModalCommentsService from "../components/ModalCommentsService.vue";
import ModalServicesDeleted from "../components/ModalServicesDeleted.vue";
import { formatDateToFormatCommon } from "@/helpers/common";
import ModalShowApprovers from "../components/ModalShowApprovers.vue";
import {
  getCurrentApprover,
  getCurrentApproverSaleOc,
  getSubstituteFromApprover,
} from "@/helpers/supplying/approvals";
import config from "@/config";
import { BUSINESS_UNIT_RESIDENTIAL_CODE } from "@/constants/presale";
import { getCustomProjectCodeIfIsOv } from "@/helpers/project";
export default {
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "Órdenes de Compra",
    },
    requestingUserModule: {
      type: Boolean,
      default: false,
    },
    requestQuote: {
      type: Boolean,
      default: false,
    },
    requestPurchaseOrder: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    FilterProject,
    FilterCeco,
    TableServicesDetail,
    ModalCommentsService,
    ModalServicesDeleted,
    ModalShowApprovers,
  },
  mounted() {
    if (!this.wrappedListEmployeesToAssignRequestOc.length) {
      this.getListEmployeesToAssignRequestOcData();
    }
    this.getBusinessUnits();
    this.getRequestServicesQuotesData();
    this.getUserIsSupplyingUserData();
  },
  data() {
    return {
      loading: false,
      REQUEST_MATERIAL,
      REQUEST_SERVICE_MAVERICK,
      REQUEST_SERVICE_CONSTANTS,
      dialogCommmentsRequest: false,
      dialogServicesDeleted: false,
      dialogShowApprovers: false,
      dialogCancelSoc: false,
      currentRequest: null,
      currentSocToCancel: null,
      cancelSocReason: "",
      cancelSocLoading: false,
      userIsSupplyingUser: false,
      statusRequestsApprovalRequest: STATUS_REQUESTS_MATERIALS,
      loadingQuotes: false,
      debounceTime: 500,
      keyTableRequests: 1000,
      debounceRequests: null,
      debounceQuotes: null,
      debounceEmployees: null,
      breadcrumb: [
        {
          text: "Inicio",
          disabled: false,
          href: "/",
        },
        {
          text: this.title,
          disabled: true,
          href: "/requestServices/quotes/list",
        },
      ],
      expanded: [],
      tableHeaders: [
        {
          text: "Acción",
          align: "center",
          value: "action",
          sortable: false,
          
        },
        {
          text: "Cesta Compra",
          align: "center",
          value: "sale_order",
          sortable: true,
          
        },
        {
          text: "Proyecto/OV/CECO",
          align: "center",
          value: "code",
          
          sortable: true,
        },
        {
          text: "Tipo de Solicitud",
          align: "center",
          value: "material_request_type",
          
          sortable: false,
        },
        {
          text: "Usuario que Solicita",
          align: "center",
          value: "user",
          
          sortable: false,
        },
        {
          text: "Comprador Asignado",
          align: "center",
          value: "assigned_users",
          
          sortable: false,
        },
        {
          text: "Fecha de Creación",
          align: "center",
          value: "created_at",
          
          sortable: true,
        },
        {
          text: "Fecha Última Modificación",
          align: "center",
          value: "updated_at",
          
          sortable: false,
        },
        {
          text: "Aprobador Siguiente",
          align: "center",
          value: "approver_current",
          
          sortable: false,
        },
        {
          text: "Estatus",
          align: "center",
          value: "status",
          
          sortable: false,
        },
        { text: "Servicios", align: "center", value: "data-table-expand",  },
      ],
      datepicker_menu_start: false,
      datepicker_menu_end: false,
      filters: {
        page: 1,
        assigned_filter: null,
        status_filter: null,
        only_pending: false,
        filter: "",
        date_start: null,
        date_end: null,
        business_unit: null,
        project_code: null,
        ceco_code: null,
        sort_by: "created_at",
        sort_order: "desc",
      },
      unifiedSupplyReviewFilterValue: "pending_review_supply_group",
      unifiedSupplyReviewLabel: "Pendiente de revisión por Abastecimiento",
      unifiedSupplyReviewStatuses: [
        "Pendiente de Revisión por Abastecimiento",
        "Pendiente de Revisión por Abastecimiento (Maverick)",
        "Pendiente de Aprobación (solo por parte del equipo de compras)",
      ],
      unifiedSupplyReviewBadgeStatuses: [
        REQUEST_SERVICE_CONSTANTS.service_statuses.purchase_validation,
        REQUEST_SERVICE_CONSTANTS.service_statuses.purchase_validation_variant,
        // "Pendiente de Aprobacion (solo por parte del equipo de compras)",
      ],
      unifiedSupplyReviewBackendStatuses: [
        REQUEST_SERVICE_CONSTANTS.service_statuses.purchase_validation,
        REQUEST_SERVICE_CONSTANTS.service_statuses.purchase_validation_variant,
        REQUEST_SERVICE_CONSTANTS.service_statuses.pending,
      ],
    };
  },
  methods: {
    ...mapActions({
      getUserIsSupplyingUser: "requestService/getUserIsSupplyingUser",
      getRequestServicesQuotes: "requestService/getRequestServicesQuotes",
      updateRequestType: "requestService/updateRequestType",
      getExchangeRate: "requestService/getExchangeRate",
      getProjects: "requestMaterialsSap/getProjects",
      getCecos: "requestMaterialsSap/getCecos",
      getBusinessUnits: "requestMaterial/getBusinessUnits",
      sendUpdateRequestToPendingApproval:
        "requestService/updateStatusRequestToPendingApproval",
      sendUpdateRequestMaverickToPendingApproval:
        "requestService/updateStatusRequestMaverickToPendingApproval",
      sendUpdateStatusRequestToReview:
        "requestService/updateStatusRequestToReview",
      sendUpdateStatusRequestMaverickToReviewUser:
        "requestService/updateStatusRequestMaverickToReviewUser",
      sendUpdateStatusRequestToReviewUser:
        "requestService/updateStatusRequestToReviewUser",
      sendUpdateStatusRequestMaverickToReviewPurchase:
        "requestService/updateStatusRequestMaverickToReviewPurchase",
      sendUpdateStatusRequestToReviewPurchase:
        "requestService/updateStatusRequestToReviewPurchase",
      sendUpdateStatusRequestMaverickToRejection:
        "requestService/updateStatusRequestMaverickToRejection",
      sendUpdateStatusRequestToRejection:
        "requestService/updateStatusRequesToRejection",
      sendUpdateStatusRequestToQuotation:
        "requestService/updateStatusRequestToQuotation",
      sendUpdateStatusRequestToApproveFromPurchase:
        "requestService/updateStatusRequestToApproveFromPurchase",
      sendCancelPurchaseOrderRequest:
        "requestService/cancelPurchaseOrderRequest",
      getListEmployeesToAssignRequestOc:
        "quote/getListEmployeesToAssignRequestQuote",
      assignUserToRequestOc: "requestService/assignUserToRequestOc",
      unassignUserToRequestOc: "requestService/unassignUserToRequestOc",
    }),
    formatDateToFormatCommon,
    getCustomProjectCodeIfIsOv,
    async getListEmployeesToAssignRequestOcData(search = null) {
      let self = this;
      if (search === null || !search.includes("(")) {
        clearTimeout(self.debounceEmployees);
        self.debounceEmployees = await setTimeout(async function() {
          await self.getListEmployeesToAssignRequestOc({
            page: 0,
            password: config.password_manteiners,
            quotation_approvers: true,
            filter: search ?? undefined,
            items: 50,
          });
        }, self.debounceTime);
      }
    },
    async assignUserToRequest(value, request) {
      this.loading = true;
      let payload = {
        user: this.user.email,
        request_id: request.id,
        approver_id: value,
      };

      if (request.assigned_users.length) {
        await this.unassignUserToRequestOc({
          ...payload,
          approver_id: request.assigned_users[0].user.id,
        });
      }

      const resp = await this.assignUserToRequestOc(payload);
      if (!resp || !resp.status || resp.status == 500) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Ha ocurrido un error en el servidor, intenta nuevamente",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      if (resp.status == 400) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: resp.data.detail,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }
      if (resp.status == 200) {
        this.$swal({
          icon: "success",
          title: "Excelente",
          text: `Usuario asignado correctamente`,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
        this.getRequestServicesQuotesData();
      }
      this.loading = false;
    },
    async getUserIsSupplyingUserData() {
      if (this.user) {
        const resp = await this.getUserIsSupplyingUser({
          user: this.user.email,
        });
        this.userIsSupplyingUser = resp ? resp.is_abastecimiento : false;
      }
    },
    rowColor(item) {
      if (item.is_maverick) {
        return "bg-maverick";
      }
      return "";
    },
    getStatusColorApprovalRequest(item) {
      if (
        item.approval_request &&
        (item.approval_request.rejected || item.approval_request.cancelled)
      ) {
        return "red darken-2";
      }

      if (REQUEST_SERVICE_CONSTANTS.ifAllServicesHaveOC(item)) {
        return "success";
      }

      if (
        item.approval_request.sent_to_erp &&
        (item.approval_request.sale_order_created ||
          !item.approval_request.sale_approvers.length)
      ) {
        return "blue darken-2";
      }

      return "purple";
    },
    getStatusCorrection(status) {
      return REQUEST_SERVICE_CONSTANTS.getStatusCorrection(status);
    },
    // Normaliza el estado para comparaciones, eliminando acentos y espacios.
    normalizeStatus(status) {
      return (status || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase();
    },
    isUnifiedSupplyReviewStatus(status) {
      if (!status) {
        return false;
      }

      return this.unifiedSupplyReviewBadgeStatuses.includes(status);
    },
    isStatusInUnifiedSupplyReviewFilter(status) {
      if (!status) {
        return false;
      }

      const normalizedStatus = this.normalizeStatus(status);
      const normalizedCorrectedStatus = this.normalizeStatus(
        this.getStatusCorrection(status),
      );

      return (
        this.unifiedSupplyReviewStatusNormalizedSet.has(normalizedStatus) ||
        this.unifiedSupplyReviewStatusNormalizedSet.has(
          normalizedCorrectedStatus,
        )
      );
    },
    getStatusCorrectionDisplay(status) {
      if (this.isUnifiedSupplyReviewStatus(status)) {
        return this.unifiedSupplyReviewLabel;
      }
      return this.getStatusCorrection(status);
    },
    getStatusColorDisplay(status) {
      if (this.isUnifiedSupplyReviewStatus(status)) {
        return "#FF8C00";
      }
      return this.getStatusColor(status);
    },
    getAssignedBuyerEmail(request) {
      return request.assigned_users && request.assigned_users.length
        ? request.assigned_users[0].user.email
        : null;
    },
    currentUserIsAdminOrSuperAdmin() {
      if (!this.user || !this.user.nombre_rol) {
        return false;
      }

      const roleName = this.user.nombre_rol.toUpperCase();
      return roleName === "SUPER USUARIO" || roleName.includes("ADMIN");
    },
    canManageSocStatus(request) {
      if (!this.requestPurchaseOrder || !this.user) {
        return false;
      }

      return (
        this.userIsSupplyingUser ||
        this.currentUserIsAdminOrSuperAdmin() ||
        this.getAssignedBuyerEmail(request) === this.user.email
      );
    },
    userCanCancelPurchaseOrderRequest(request) {
      return this.canManageSocStatus(request);
    },
    getCurrentPendingApprovers(request) {
      if (!request || !request.approval_request) {
        return [];
      }

      return request.approval_request.sent_to_erp
        ? getCurrentApproverSaleOc(request.approval_request)
        : getCurrentApprover(request.approval_request);
    },
    requestHasPendingApprovalWithoutValidApprover(request) {
      if (request.approval_request) {
        if (
          request.approval_request.cancelled ||
          request.approval_request.rejected ||
          request.approval_request.sale_order_created
        ) {
          return false;
        }

        return !this.getCurrentPendingApprovers(request).length;
      }

      return request.status === REQUEST_SERVICE_CONSTANTS.service_statuses.pending;
    },
    canCancelPurchaseOrderRequest(request) {
      return this.userCanCancelPurchaseOrderRequest(request);
    },
    canOpenQuickStatusActionsFromBadge(request) {
      if (!this.canManageSocStatus(request)) {
        return false;
      }

      return (
        this.getStatusCorrectionDisplay(request.status) ===
          this.unifiedSupplyReviewLabel &&
        !request.cancelled &&
        !request.rejected
      );
    },
    getSocStatusActionConfig(actionType) {
      if (actionType === "rejected") {
        return {
          title: "Rechazar",
          buttonText: "Rechazar",
          successText: "SOC rechazada correctamente",
          icon: "error",
          color: "#D32F2F",
          placeholder: "Motivo de rechazo (opcional)",
        };
      }

      return {
        title: "Anular / Cancelar",
        buttonText: "Anular SOC",
        successText: "SOC anulada correctamente",
        icon: "warning",
        color: "#D32F2F",
        placeholder: "Motivo de anulación (opcional)",
      };
    },
    applySocStatusLocally(requestService, actionType, comment = "") {
      const currentDateIso = new Date().toISOString();
      this.$set(requestService, "updated_at", currentDateIso);

      if (actionType === "rejected") {
        this.$set(
          requestService,
          "status",
          REQUEST_SERVICE_CONSTANTS.service_statuses.rejected_variant,
        );
        this.$set(requestService, "rejected", true);
        this.$set(requestService, "cancelled", false);

        if (requestService.approval_request) {
          this.$set(requestService.approval_request, "rejected", true);
          this.$set(requestService.approval_request, "cancelled", false);
          this.$set(requestService.approval_request, "rejected_at", currentDateIso);
          this.$set(
            requestService.approval_request,
            "rejected_by",
            this.user ? this.user.email : null,
          );
          if (comment) {
            this.$set(requestService.approval_request, "rejected_comment", comment);
          }
        }
        return;
      }

      this.$set(
        requestService,
        "status",
        REQUEST_SERVICE_CONSTANTS.service_statuses.cancelled,
      );
      this.$set(requestService, "cancelled", true);
      this.$set(requestService, "rejected", false);

      if (requestService.approval_request) {
        this.$set(requestService.approval_request, "cancelled", true);
        this.$set(requestService.approval_request, "rejected", false);
        if (comment) {
          this.$set(requestService.approval_request, "cancelled_comment", comment);
        }
      }
    },
    handleAnularSOC(requestService) {
      if (!this.canManageSocStatus(requestService)) {
        return this.$swal({
          icon: "warning",
          title: "Sin permisos",
          text:
            "Solo el comprador asignado o perfiles de Abastecimiento/Admin pueden realizar esta acción.",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
        });
      }

      this.currentSocToCancel = requestService;
      this.cancelSocReason = "";
      this.dialogCancelSoc = true;
    },
    closeCancelSocDialog() {
      if (this.cancelSocLoading) {
        return;
      }

      this.dialogCancelSoc = false;
      this.currentSocToCancel = null;
      this.cancelSocReason = "";
    },
        async handleConfirmAnulacion() {
      if (!this.currentSocToCancel || this.cancelSocLoading) {
        return;
      }

      const currentSoc = this.currentSocToCancel;

      // FIX MSCN-297: Validar que el usuario actual sea el comprador asignado
      // antes de proceder con la anulación
      const assignedBuyerEmail = this.getAssignedBuyerEmail(currentSoc);
      if (assignedBuyerEmail && assignedBuyerEmail !== this.user.email) {
        this.$swal({
          icon: "warning",
          title: "Acción no permitida",
          text: "Acción no permitida: Solo el comprador asignado a esta SOC puede anularla o cancelarla.",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
        });
        return;
      }

      const cancelReason = this.cancelSocReason || '';
      const socId = currentSoc.id;

      this.cancelSocLoading = true;
      try {
        const response = await this.sendCancelPurchaseOrderRequest({
          request_id: socId,
          user: this.user.email,
          comment: cancelReason,
        });

        // FIX MSCN-297: Evaluar correctamente la respuesta del backend
        // SOLO mostrar éxito si res.data.success es true
        if (!response || !response.data || response.data.success !== true) {
          // Si success es false, mostrar el mensaje de error de la API
          if (response?.data?.success === false && response?.data?.message) {
            this.$swal({
              icon: "error",
              title: "Error",
              text: response.data.message,
              position: "top-end",
              showConfirmButton: false,
              toast: true,
              timer: 5000,
              timerProgressBar: true,
            });
          } else if (!response?.data?.success) {
            this.$swal({
              icon: "error",
              title: "Error",
              text: "La solicitud no pudo ser procesada. Por favor intente nuevamente.",
              position: "top-end",
              showConfirmButton: false,
              toast: true,
              timer: 4000,
              timerProgressBar: true,
            });
          }
          return;
        }

        // Si success es true, mostrar mensaje de éxito y recargar
        this.applySocStatusLocally(currentSoc, "cancelled", cancelReason);
        this.cancelSocLoading = false;
        this.closeCancelSocDialog();
        this.$swal({
          icon: "success",
          title: "Excelente",
          text: "SOC anulada correctamente",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
        });
        // this.$emit('refresh-list') - opcional
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Ha ocurrido un error al procesar la anulación de la SOC.",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
        });
      } finally {
        this.cancelSocLoading = false;
      }
    },
    async executeSocStatusAction(requestService, actionType, comment = "") {
      let payload = {
        request_id: requestService.id,
        user: this.user.email,
        comment: comment || "",
      };

      if (actionType === "rejected") {
        if (requestService.is_maverick) {
          return this.sendUpdateStatusRequestMaverickToRejection(payload);
        }
        return this.sendUpdateStatusRequestToRejection(payload);
      }

      return this.sendCancelPurchaseOrderRequest(payload);
    },
    async openSocStatusDecisionModal(requestService, actionType) {
      if (actionType === "cancelled") {
        return this.handleAnularSOC(requestService);
      }

      if (!this.canManageSocStatus(requestService)) {
        return this.$swal({
          icon: "warning",
          title: "Sin permisos",
          text:
            "Solo el comprador asignado o perfiles de Abastecimiento/Admin pueden realizar esta acción.",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
        });
      }

      if (
        actionType === "cancelled" &&
        !this.canCancelPurchaseOrderRequest(requestService)
      ) {
        return this.$swal({
          icon: "warning",
          title: "Acción no disponible",
          text:
            "Esta SOC no cumple las condiciones para anulación/cancelación en su estado actual.",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
        });
      }

      const config = this.getSocStatusActionConfig(actionType);
      const result = await this.$swal.fire({
        icon: config.icon,
        title: `¿Estás seguro de ${config.title.toLowerCase()} la SOC con Cesta de Compra: <b>${requestService.sale_order}</b>?`,
        text:
          "Esta acción impactará el flujo actual de la solicitud. Puedes agregar un motivo opcional.",
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonColor: config.color,
        confirmButtonText: config.buttonText,
        cancelButtonText: "Volver",
        width: "55%",
        input: "textarea",
        inputPlaceholder: config.placeholder,
      });

      if (!result.isConfirmed) {
        return;
      }

      this.loading = true;
      const response = await this.executeSocStatusAction(
        requestService,
        actionType,
        result.value,
      );

      if (!response || !response.status || response.status == 500) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Ha ocurrido un error en el servidor, intenta nuevamente",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
        this.loading = false;
        return;
      }

      if (response.status == 400) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: response.data.detail,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 5000,
          timerProgressBar: true,
        });
        this.loading = false;
        return;
      }

      if (response.status == 200) {
        this.applySocStatusLocally(requestService, actionType, result.value);
        this.$swal({
          icon: "success",
          title: "Excelente",
          text: config.successText,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 4000,
          timerProgressBar: true,
        });
      }

      this.loading = false;
    },
    clickedRow(value) {
      if (this.expanded.find((item) => item.id == value.id)) {
        return (this.expanded = this.expanded.filter(
          (item) => item.id !== value.id,
        ));
      }
      this.expanded.push(value);
    },
    async updateStatusInReviewRequest(requestService) {
      let self = this;
      if (
        !self.requestingUserModule &&
        requestService.items.find(
          (item) =>
            item.status ==
            REQUEST_SERVICE_CONSTANTS.service_statuses.in_quotation,
        )
      ) {
        clearTimeout(self.debounceRequests);
        self.debounceRequests = setTimeout(async () => {
          const resp = await self.sendUpdateStatusRequestToReview({
            request_id: requestService.id,
            user: self.user.email,
          });
        }, self.debounceTime);
      }
    },
    clearDateFilters() {
      this.filters.date_start = null;
      this.filters.date_end = null;
      this.getRequestServicesQuotesData(this.filters.page);
    },
    updateCurrentProject(project_code) {
      this.filters.project_code = project_code;
    },
    cleanCurrentProject() {
      this.filters.project_code = null;
    },
    updateCurrentCeco(ceco_code) {
      this.filters.ceco_code = ceco_code;
    },
    cleanCurrentCeco() {
      this.filters.ceco_code = null;
    },
    getStatusColor(status) {
      return REQUEST_SERVICE_CONSTANTS.getStatusColor(status);
    },
    async changeProjectFilter() {
      let self = this;
      self.getRequestServicesQuotesData(1);
    },
    async fetchRequestServicesQuotes(
      page = this.filters.page,
      update_current_service = false,
      updateTable = false,
    ) {
      let self = this;
      self.filters.page = page || 1;
      self.loadingQuotes = true;
      try {
        await this.getRequestServicesQuotes({
          page: self.filters.page,
          general_filter: this.filters.filter ? this.filters.filter : undefined,
          project_code: this.filters.project_code
            ? this.filters.project_code.split(" - ")[0]
            : undefined,
          cost_center: this.filters.ceco_code
            ? this.filters.ceco_code.split(" - ")[0]
            : undefined,
          user:
            this.requestingUserModule && this.user
              ? this.user.email
              : undefined,
          business_unit: this.filters.business_unit
            ? this.filters.business_unit
            : undefined,
          since_date: this.filters.date_start
            ? `${this.filters.date_start}`
            : undefined,
          until_date: this.filters.date_end
            ? `${this.filters.date_end}`
            : undefined,
          status_filter: this.filters.status_filter
            ? this.filters.status_filter === this.unifiedSupplyReviewFilterValue
              ? this.unifiedSupplyReviewFilterValue
              : this.filters.status_filter
            : undefined,
          sort_by: this.filters.sort_by ? this.filters.sort_by : undefined,
          sort_order: this.filters.sort_order
            ? this.filters.sort_order
            : undefined,
          assigned_filter:
            this.filters.assigned_filter &&
            this.filters.assigned_filter !==
              REQUEST_SERVICE_CONSTANTS.unassigned_purchase_user
              ? this.filters.assigned_filter
              : undefined,
          unassigned:
            this.filters.assigned_filter &&
            this.filters.assigned_filter ===
              REQUEST_SERVICE_CONSTANTS.unassigned_purchase_user
              ? true
              : undefined,
        });
        if (update_current_service) {
          setTimeout(() => {
            if (self.$refs && self.$refs.tableServicesDetail) {
              self.$refs.tableServicesDetail.updateFilesCurrentService();
            }
          }, 1000);
        }
        if (updateTable) {
          self.keyTableRequests = self.keyTableRequests + 1;
        }
      } finally {
        self.loadingQuotes = false;
      }
    },
    getRequestServicesQuotesData(
      page = this.filters.page,
      update_current_service = false,
      updateTable = false,
    ) {
      let self = this;
      clearTimeout(self.debounceQuotes);
      self.filters.page = page || 1;
      self.debounceQuotes = setTimeout(async () => {
        await self.fetchRequestServicesQuotes(
          self.filters.page,
          update_current_service,
          updateTable,
        );
      }, self.debounceTime);
    },
    async changeQuotesPage(page) {
      if (this.loadingQuotes) return;
      clearTimeout(this.debounceQuotes);
      await this.fetchRequestServicesQuotes(page);
    },
    async updateSortBy(sortBy) {
      if (sortBy) {
        this.filters.sort_by =
          sortBy == "sale_order"
            ? "order"
            : sortBy == "code"
            ? "project"
            : sortBy;
        this.filters.sort_order = "asc";
        await this.fetchRequestServicesQuotes(1);
      } else {
        this.filters.sort_by = "created_at";
        this.filters.sort_order = "desc";
        await this.fetchRequestServicesQuotes(1);
      }
    },
    async updateSortDesc(sortDesc) {
      if (sortDesc) {
        this.filters.sort_order = "desc";
        await this.fetchRequestServicesQuotes(1);
      }
    },
    customSort(items, index, isDesc, column) {
      return items;
    },

    requestIsStatusInPendingValidation(request) {
      return (
        request.status ===
        REQUEST_SERVICE_CONSTANTS.service_statuses.pending_validation
      );
    },
    requestIsStatusUserValidationVariant(request) {
      return (
        request.status ===
        REQUEST_SERVICE_CONSTANTS.service_statuses.user_validation_variant
      );
    },
    requestIsStatusInPurchaseValidation(request) {
      return (
        request.status ===
        REQUEST_SERVICE_CONSTANTS.service_statuses.purchase_validation
      );
    },
    requestIsStatusInPurchaseValidationVariant(request) {
      return (
        request.status ===
        REQUEST_SERVICE_CONSTANTS.service_statuses.purchase_validation_variant
      );
    },
    requestIsStatusInUserValidation(request) {
      return (
        request.status ===
        REQUEST_SERVICE_CONSTANTS.service_statuses.user_validation
      );
    },
    formatAmount(amount, showDecimals = true) {
      if (showDecimals) {
        return new Intl.NumberFormat("es-Cl", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(amount.toString());
      } else {
        return new Intl.NumberFormat("es-Cl", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(amount.toString());
      }
    },
    createExchangeRateTable(items, totalPrice = 0) {
      // Create the table structure
      let table = `<table style='border: 1px solid #dededf; height: 100%;width: 100%;table-layout: fixed;border-collapse: collapse;border-spacing: 1px;text-align: left;color: #595959'>
          <thead>
            <tr>
              <th style='border: 1px solid #dededf;background-color: #2778C4;color: #FFFFFF;padding: 5px;'>Descripción</th>
              <th style='border: 1px solid #dededf;background-color: #2778C4;color: #FFFFFF;padding: 5px;'>Tasa de Cambio Utilizada</th>
              <th style='border: 1px solid #dededf;background-color: #2778C4;color: #FFFFFF;padding: 5px;'>Precio</th>
              <th style='border: 1px solid #dededf;background-color: #2778C4;color: #FFFFFF;padding: 5px;'>Monto en Pesos</th>
            </tr>
          </thead>
          <tbody>
        `;

      // Populate the table with items
      items.forEach((item) => {
        table += `
        <tr>
          <td style='border: 1px solid #dededf;background-color: #ffffff;padding: 5px;'>
            ${item.name}
          </td>
          <td style='border: 1px solid #dededf;background-color: #ffffff;padding: 5px;'>
            ${`${item.exchange_rate}`}
          </td>
          <td style='border: 1px solid #dededf;background-color: #ffffff;padding: 5px;'>
            ${item.unit_amount} ${item.coin}
          </td>
          <td style='border: 1px solid #dededf;background-color: #ffffff;padding: 5px;'>
            ${item.coin !== "CLP" ? `${item.amount} CLP` : "---"}
          </td>
        </tr>`;
      });

      // add total CLP
      table += `
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td style='border: 1px solid #dededf;background-color: #2778C4;color: #FFFFFF;padding: 5px;'>${totalPrice} CLP</td>
        </tr>`;

      // Close the table
      table += "</tbody></table>";

      return table;
    },
    async resolveExchangeRateTable(items) {
      const coins = [
        ...new Set(
          items
            .filter((item) => item.coin && item.coin !== "CLP")
            .map((item) => item.coin),
        ),
      ];
      let exchangeRates = [];
      if (coins.length) {
        const promises = coins.map(async (item) => {
          return this.getExchangeRate({ to_currency: item });
        });
        exchangeRates = await Promise.all(promises);
      }

      let totalPrice = 0;
      const dataExchangeTable = items.map((item) => {
        if (item.coin && item.coin !== "CLP") {
          const exchange = exchangeRates.find(
            (exchange) => exchange.to_currency == item.coin,
          );
          totalPrice += Math.round(item.unit_price * exchange.rate * 100) / 100;
          return {
            ...item,
            coin: item.coin ? item.coin : "CLP",
            unit_amount: this.formatAmount(
              item.unit_price,
              item.coin && item.coin !== "CLP",
            ),
            amount: this.formatAmount(
              Math.round(item.unit_price * exchange.rate * 100) / 100,
              false,
            ),
            exchange_rate: `1 ${
              item.coin
            } ⟺ ${exchange.rate.toString().replaceAll(".", ",")} CLP`,
          };
        } else {
          totalPrice += item.unit_price;
          return {
            ...item,
            coin: "CLP",
            unit_amount: this.formatAmount(item.unit_price, false),
            amount: this.formatAmount(item.unit_price, false),
            exchange_rate: "---",
          };
        }
      });

      return this.createExchangeRateTable(
        dataExchangeTable,
        this.formatAmount(totalPrice, false),
      );
    },
    async updateStatusRequest(requestService) {
      const exchangeRates = await this.resolveExchangeRateTable(
        requestService.items,
      );

      if (
        !requestService.is_maverick &&
        requestService.items.find((item) => {
          return (
            REQUEST_SERVICE_CONSTANTS.getServiceQuotesPostService(item).length >
              1 && !item.documents.find((document) => document.selected)
          );
        })
      ) {
        return this.$swal.fire({
          icon: "error",
          title: "Error",
          text:
            "Si hay mas de 1 cotización en un servicio, debes seleccionar 1 en la sección de documentos del servicio para continuar",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 7000,
          timerProgressBar: true,
        });
      }
      this.$swal
        .fire({
          icon: "info",
          title: `¿Estás seguro de enviar solicitud con Cesta de Compra: <b>${requestService.sale_order}</b> a la Matriz de Aprobación?`,
          footer: exchangeRates,
          width: "70%",
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "#1076D0",
          confirmButtonText: `Enviar`,
          cancelButtonText: `Cancelar`,
          width: "70%",
          
          input: "textarea",
          inputPlaceholder: "Ingresa un comentario de justificación...",
            preConfirm: (inputValue) => {
            if (!inputValue) {
              return this.$swal.showValidationMessage(
                "Por favor, ingresa un comentario de justificación",
              );
            }
            return inputValue;
          },
        })

        .then(async (result) => {
          if (result.isConfirmed) {
            this.loading = true;
            let resp = null;
            let payload = {
              comment: result.value,
              request_id: requestService.id,
              user: this.user.email,
              send_to_approval: true,
            };
            if (requestService.is_maverick) {
              resp = await this.sendUpdateRequestMaverickToPendingApproval(
                payload,
              );
            } else if (
              this.requestIsStatusInPurchaseValidationVariant(requestService)
            ) {
              resp = await this.sendUpdateStatusRequestToApproveFromPurchase(
                payload,
              );
            } else {
              resp = await this.sendUpdateRequestToPendingApproval(payload);
            }
            if (!resp || !resp.status || resp.status == 500) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: "Ha ocurrido un error en el servidor, intenta nuevamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 400) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: resp.data.detail.message
                  ? resp.data.detail.message.value
                  : resp.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
              this.getRequestServicesQuotesData();
            }
            if (resp.status == 200) {
              this.$swal({
                icon: "success",
                title: "Excelente",
                text: `Solicitud enviada correctamente a la matriz de aprobación, puede hacer seguimiento en la sección de aprobaciones`,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 7000,
                timerProgressBar: true,
              });
              this.getRequestServicesQuotesData();
            }
            this.loading = false;
          }
        });
    },
    async updateStatusRequestToReviewUser(requestService) {
      const exchangeRates = await this.resolveExchangeRateTable(
        requestService.items,
      );
      this.$swal
        .fire({
          icon: "warning",
          title: `¿Estás seguro de enviar esta Solicitud con Cesta de Compra: <b>${requestService.sale_order}</b> a Revisión por el Usuario?`,
          footer: requestService.is_maverick ? exchangeRates : null,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "#FF9900",
          confirmButtonText: `Enviar`,
          cancelButtonText: `Cancelar`,
          width: "70%",
          input: "textarea",
          inputPlaceholder: "Ingresa el feedback para el usuario solicitante",
          preConfirm: (inputValue) => {
            if (!inputValue) {
              return this.$swal.showValidationMessage(
                "Por favor, ingresa el feedback",
              );
            }
            return inputValue;
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            let resp = null;
            this.loading = true;
            let payload = {
              request_id: requestService.id,
              user: this.user.email,
              comment: result.value,
            };
            if (requestService.is_maverick) {
              resp = await this.sendUpdateStatusRequestMaverickToReviewUser(
                payload,
              );
            } else {
              resp = await this.sendUpdateStatusRequestToReviewUser(payload);
            }
            if (!resp || !resp.status || resp.status == 500) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: "Ha ocurrido un error en el servidor, intenta nuevamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 400) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: resp.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 200) {
              this.$swal({
                icon: "success",
                title: "Excelente",
                text: `Solicitud enviada correctamente a revisión por parte del usuario`,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
              this.getRequestServicesQuotesData();
            }
            this.loading = false;
          }
        });
    },
    async updateStatusRequestToQuotation(requestService) {
      this.$swal
        .fire({
          icon: "warning",
          title: `¿Estas seguro de Solicitar una Recotización para la solicitud con Cesta de Compra: <b>${requestService.sale_order}</b> ?`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "#FF9900",
          confirmButtonText: `Solicitar`,
          cancelButtonText: `Cancelar`,
          width: "50%",
          input: "textarea",
          inputPlaceholder: "Ingresa el feedback para el equipo de compras",
          preConfirm: (inputValue) => {
            if (!inputValue) {
              return this.$swal.showValidationMessage(
                "Por favor, ingresa el feedback",
              );
            }
            return inputValue;
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            this.loading = true;
            let payload = {
              request_id: requestService.id,
              user: this.user.email,
              comment: result.value,
            };
            const resp = await this.sendUpdateStatusRequestToQuotation(payload);

            if (!resp || !resp.status || resp.status == 500) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: "Ha ocurrido un error en el servidor, intenta nuevamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 400) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: resp.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 200) {
              this.$swal({
                icon: "success",
                title: "Excelente",
                text: `Recotización solicitada correctamente`,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
              this.getRequestServicesQuotesData(this.filters.page, false, true);
            }
            this.loading = false;
          }
        });
    },
    async updateStatusRequestToReviewPurchase(requestService) {
      if (
        !requestService.is_maverick &&
        requestService.items.find((item) => {
          return (
            REQUEST_SERVICE_CONSTANTS.getServiceQuotesPostService(item).length >
              1 && !item.documents.find((document) => document.selected)
          );
        })
      ) {
        return this.$swal.fire({
          icon: "error",
          title: "Error",
          text:
            "Si hay mas de 1 cotización en un servicio, debes seleccionar 1 en la sección de documentos del servicio para continuar",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 7000,
          timerProgressBar: true,
        });
      }
      const exchangeRates = await this.resolveExchangeRateTable(
        requestService.items,
      );
      this.$swal
        .fire({
          icon: "info",
          title: `¿Estás seguro de Enviar esta Solicitud con Cesta de Compra: <b>${requestService.sale_order}</b> a Revisión por Compras?`,
          footer: exchangeRates,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonColor: "#1076D0",
          confirmButtonText: `Enviar`,
          cancelButtonText: `Cancelar`,
          width: "70%",
          input: "textarea",
          inputPlaceholder: "Ingresa el feedback para el equipo de compras",
          preConfirm: (inputValue) => {
            if (!inputValue) {
              return this.$swal.showValidationMessage(
                "Por favor, ingresa el feedback",
              );
            }
            return inputValue;
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            let resp = null;
            this.loading = true;
            let payload = {
              request_id: requestService.id,
              user: this.user.email,
              comment: result.value,
            };
            if (requestService.is_maverick) {
              resp = await this.sendUpdateStatusRequestMaverickToReviewPurchase(
                payload,
              );
            } else {
              resp = await this.sendUpdateStatusRequestToReviewPurchase(
                payload,
              );
            }

            if (!resp || !resp.status || resp.status == 500) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: "Ha ocurrido un error en el servidor, intenta nuevamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 400) {
              this.$swal({
                icon: "error",
                title: "Error",
                text: resp.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
            }
            if (resp.status == 200) {
              this.$swal({
                icon: "success",
                title: "Excelente",
                text: `Solicitud enviada correctamente a revisión por parte del equipo de compras`,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
              this.getRequestServicesQuotesData();
            }
            this.loading = false;
          }
        });
    },
    async updateStatusRequestToRejection(requestService) {
      this.openSocStatusDecisionModal(requestService, "rejected");
    },
    async cancelPurchaseOrderRequest(requestService) {
      this.handleAnularSOC(requestService);
    },
    openModalCommentsRequest(item) {
      this.currentRequest = item;
      this.dialogCommmentsRequest = true;
    },
    closeModalCommentsRequest() {
      this.currentRequest = null;
      this.dialogCommmentsRequest = false;
    },
    openModalServicesDeleted(item) {
      this.currentRequest = item;
      this.dialogServicesDeleted = true;
    },
    closeModalServicesDeleted() {
      this.currentRequest = null;
      this.dialogServicesDeleted = false;
    },
    openModalShowApprovers(item) {
      this.currentRequest = item;
      this.dialogShowApprovers = true;
    },
    closeModalShowApprovers() {
      this.currentRequest = null;
      this.dialogShowApprovers = false;
    },
   
    async confirmChangeRequestType(item) {
      const requestTypeOptions = [
        {
          
          // apiValue: TYPE_REQUESTS_SERVICE.find((type) => type.name === REQUEST_SERVICE)?.value || 1,
          apiValue: TYPE_REQUESTS_SERVICE.find((type) => type.name === REQUEST_MATERIAL)?.value || 1,
          // requestTypeName: REQUEST_SERVICE,
          requestTypeName: REQUEST_MATERIAL,
          label: 'SOC',
        },
        {
          apiValue: TYPE_REQUESTS_SERVICE.find((type) => type.name === REQUEST_SERVICE_MAVERICK)?.value || 3,
          requestTypeName: REQUEST_SERVICE_MAVERICK,
          label: 'MAVERICK',
        },
      ];

      // const currentType = item.request_type === REQUEST_SERVICE ? 'SOC' : 'MAVERICK';
      const currentType = item.request_type === REQUEST_MATERIAL ? 'SOC' : 'MAVERICK';

      const result = await this.$swal.fire({
        icon: 'question',
        title: 'Modificar tipo de solicitud',
        html: `
          <p style="margin-bottom: 15px;">Selecciona el tipo de solicitud para <b>${item.sale_order}</b>:</p>
          <div style="display: flex; justify-content: center; gap: 20px; flex-wrap: wrap;">
            ${requestTypeOptions
              .map(
                (option) => `
                  <label style="display: flex; align-items: center; cursor: pointer; padding: 10px 15px; border: 2px solid ${option.label === currentType ? '#1976d2' : '#ddd'}; border-radius: 8px; background: ${option.label === currentType ? '#e3f2fd' : '#fff'}; transition: all 0.3s;">
                    <input type='radio' name='request-type' value='${option.apiValue}' ${option.label === currentType ? 'checked' : ''} style='margin-right: 8px;'>
                    <span style='font-weight: 500; color: ${option.label === currentType ? '#1976d2' : '#333'};'>${option.label}</span>
                  </label>
                `,
              )
              .join('')}
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: 'Modificar',
        confirmButtonColor: '#FF9900',
        cancelButtonText: 'Cancelar',
        width: '520px',
        preConfirm: () => {
          const selected = document.querySelector('input[name="request-type"]:checked');
          if (!selected) {
            this.$swal.showValidationMessage('Por favor selecciona un tipo de solicitud');
            return false;
          }
          return Number(selected.value);
        },
      });

      if (!result.isConfirmed || result.value === false) {
        return;
      }

      const selectedOption = requestTypeOptions.find((option) => option.apiValue === result.value);
      if (!selectedOption || selectedOption.requestTypeName === item.request_type) {
        return;
      }

      await this.changeRequestType(item, selectedOption);
    },
    async changeRequestType(item, selectedOption) {
      this.loading = true;
      const payload = {
        request_id: item.id,
        request_type: selectedOption.apiValue,
        request_type_name: selectedOption.requestTypeName,
        is_maverick: selectedOption.requestTypeName === REQUEST_SERVICE_MAVERICK,
        user: this.user ? this.user.email : "",
      };

      const resp = await this.updateRequestType(payload);

      if (resp && resp.status && resp.status >= 200 && resp.status < 300) {
        const newTypeText = selectedOption.label;
        this.$swal({
          icon: "success",
          title: "Excelente",
          text: `Tipo de solicitud actualizado a ${newTypeText} exitosamente.`,
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });

        item.request_type = selectedOption.requestTypeName;
        item.is_maverick = selectedOption.requestTypeName === REQUEST_SERVICE_MAVERICK;
        await this.getRequestServicesQuotesData(this.filters.page);
      } else {
        this.$swal({
          icon: "error",
          title: "Error",
          text:
            (resp && resp.data && resp.data.detail) ||
            "No se pudo cambiar el tipo de solicitud. Intenta nuevamente.",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
        });
      }

      this.loading = false;
    },

    showCurrentApprover(request) {
      if (
        !request.approval_request ||
        request.approval_request.cancelled ||
        request.approval_request.rejected
      )
        return "-";
      return request.approval_request.sent_to_erp &&
        request.approval_request.sale_order_created
        ? "Aprobado"
        : request.approval_request.sent_to_erp
        ? getCurrentApproverSaleOc(request.approval_request).length
          ? getCurrentApproverSaleOc(request.approval_request)[0].approver
              .substituting_for.length
            ? getSubstituteFromApprover(
                getCurrentApproverSaleOc(request.approval_request)[0].approver,
              ).email
            : getCurrentApproverSaleOc(request.approval_request)[0].approver
                .email
          : "-"
        : getCurrentApprover(request.approval_request).length
        ? getCurrentApprover(request.approval_request)[0].approver
            .substituting_for.length
          ? getSubstituteFromApprover(
              getCurrentApprover(request.approval_request)[0].approver,
            ).email
          : getCurrentApprover(request.approval_request)[0].approver.email
        : "-";
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      requestServicesQuotes: "requestService/requestServicesQuotes",
      projects: "requestMaterialsSap/projects",
      cecos: "requestMaterialsSap/cecos",
      businessUnits: "requestMaterial/businessUnits",
      listEmployeesToAssignRequestOc: "quote/listEmployeesToAssignRequestQuote",
    }),
    wrappedListEmployeesToAssignRequestOc() {
      return this.listEmployeesToAssignRequestOc.employees.map((item) => {
        return {
          label: `${item.email}`,
          ...item,
        };
      });
    },
    date_start_formatted: {
      get() {
        if (this.filters.date_start) {
          return moment(this.filters.date_start).format("DD/MM/YYYY");
        }
        return null;
      },
      set() {},
    },
    date_end_formatted: {
      get() {
        if (this.filters.date_end) {
          return moment(this.filters.date_end).format("DD/MM/YYYY");
        }
        return null;
      },
      set() {},
    },
    minDateEnd() {
      if (this.filters.date_start) {
        return this.filters.date_start;
      }
      return null;
    },
    maxDateStart() {
      if (this.filters.date_end) {
        return this.filters.date_end;
      }
      return null;
    },
    wrappedHeaders() {
      if (this.requestQuote) {
        return this.tableHeaders.filter(
          (header) =>
            header.value !== "code" &&
            header.value !== "stage" &&
            header.value !== "material_request_type",
        );
      }
      return this.tableHeaders;
    },
    // Crea un conjunto de estados normalizados
    //  para la revisión unificada de suministro, combinando los estados de revisión y los estados del backend.
    unifiedSupplyReviewStatusNormalizedSet() {
      return new Set(
        [
          ...this.unifiedSupplyReviewStatuses,
          ...this.unifiedSupplyReviewBackendStatuses,
        ].map((status) => this.normalizeStatus(status)),
      );
    },
    filteredRequestServicesQuotesItems() {
      return this.requestServicesQuotes?.items || [];
    },
    statusFilterOptions() {
      const options = REQUEST_SERVICE_CONSTANTS.service_statuses_list()
        .filter((status) => !this.isUnifiedSupplyReviewStatus(status))
        .map((status) => ({
          name: this.getStatusCorrection(status),
          value: status,
        }));

      return [
        {
          name: this.unifiedSupplyReviewLabel,
          value: this.unifiedSupplyReviewFilterValue,
        },
        ...options,
      ];
    },
    // Obtiene el valor único para "Pendiente de revisión por Abastecimiento"
    // para asegurar que se envíe como string simple en lugar de array
    getUnifiedSupplyReviewFilterValue() {
      return this.unifiedSupplyReviewFilterValue;
    },
  },
  watch: {},
};
</script>

<style>
.bg-maverick {
  background-color: #fff1ea !important;
}

.text-unique-supplier {
  /* Color azul cielo */
  color: purple !important;
}
.custom-font .v-select__slot {
  font-size: 12px !important;
}
.soc-status-action-list {
  padding: 8px !important;
}
.soc-status-action-item {
  min-height: 36px;
  padding: 0 8px !important;
}
.soc-status-action-title {
  display: flex !important;
  align-items: center;
  gap: 8px;
  line-height: 20px;
}
.soc-status-action-icon {
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  margin: 0 !important;
  font-size: 20px !important;
}
</style>
